<template>
  <div class="home l-container">
    <div class="mt-5 mb-5">
      <ul class="nav-list w-full">
        <li v-for="(nav, index) in navbars" :key="index">
          <a v-if="!nav.children" class="goto-button cursor-pointer" @click="$router.push(nav.path)">{{nav.name ? nav.name : nav.path}}</a>
          <ul v-else class="nav-list-child pl-4">
            <li v-for="(child, idx) in nav.children" :key="idx">
              <a class="goto-button cursor-pointer" @click="$router.push(`${nav.path}/${child.path}`)">{{child.name ? child.name : child.path}}</a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import routes from '@/router/routes'

export default {
  components: {},
  data() {
    return {
      navbars: routes
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  background-color: "#cdcdcd";
}
.nav-list {
  @apply pl-4;
  list-style-type: auto;

  &-child {
    list-style-type: circle;
  }
}


</style>